var _style, _circle, _circle2, _path, _circle3, _path2, _circle4, _circle5, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDadicateWebHosting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#0073ec}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-13.279 424.693 429.001)",
    className: "st0",
    cx: 424.7,
    cy: 429,
    r: 14.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 314.8,
    cy: 429,
    r: 14.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M471 358H29c-11.8 0-21.3 9.6-21.4 21.4v99.2c0 11.8 9.6 21.4 21.4 21.4h442c11.8 0 21.4-9.6 21.4-21.4v-99.2c0-11.8-9.6-21.4-21.4-21.4zm5.4 120.6c0 2.9-2.4 5.3-5.3 5.3H29c-2.9 0-5.3-2.4-5.3-5.3v-99.2c0-2.9 2.4-5.3 5.3-5.3h442.1c2.9 0 5.3 2.4 5.3 5.3v99.2z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 371.143 428.961)",
    className: "st0",
    cx: 371.1,
    cy: 429,
    r: 14.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M471 203.5h-7.5C458.8 94.9 373 7.4 265.1 0c-3.4-.3-6.4 2.3-6.7 5.7v.1c-.3 3.4 2.2 6.4 5.7 6.7h.1c101.8 6.7 182.3 89 186.8 190.9h-11.2c-5.9-104.8-95.6-184.9-200.4-179-96.5 5.4-173.6 82.5-179 179H49.2c4.6-101.9 85-184.1 186.7-190.9 3.4-.2 6-3.1 5.8-6.6v-.2c-.2-3.4-3.1-6-6.6-5.9h-.2C127 7.6 41.5 95 36.5 203.5H29c-11.8 0-21.4 9.6-21.4 21.4v99.2c0 11.8 9.6 21.4 21.4 21.4h442c11.8 0 21.4-9.6 21.4-21.4v-99.2c0-11.9-9.6-21.4-21.4-21.4zM93.4 130l10.7 6.1c3 1.7 6.8.7 8.6-2.3 1.7-3 .7-6.8-2.3-8.6l-10.7-6.1c14.3-22.8 33.6-42 56.3-56.3l6.1 10.7c1.6 3.1 5.4 4.2 8.5 2.6 3.1-1.6 4.2-5.4 2.6-8.5-.1-.1-.2-.3-.2-.4l-6.3-10.7c23.7-12.7 50-19.7 76.9-20.6v12.4c0 3.5 2.8 6.3 6.3 6.3s6.3-2.8 6.3-6.3V36c26.9.9 53.2 7.9 76.9 20.6L327 67.3c-1.7 3-.7 6.8 2.3 8.6 3 1.7 6.8.7 8.6-2.3l6.1-10.7c22.8 14.3 42 33.5 56.3 56.3l-10.7 6.1c-3 1.7-4 5.6-2.3 8.6 1.7 3 5.6 4 8.6 2.3l10.7-6.1c12.7 23.7 19.8 50 20.6 76.9h-81.3c-1.6-26.1-13.9-50.3-34-67l10.5-18.2c4.6-8.1 1.8-18.4-6.3-23.1-.1-.1-.2-.1-.3-.2-8-4.3-18-1.5-22.5 6.4l-10.5 18.2c-10.4-3.8-21.5-5.7-32.6-5.7-50.4 0-92.2 39.1-95.6 89.5H72.8l-.1-.1c1-26.8 8.1-53.1 20.7-76.8zm203.9 88c-2.6 25.9-25.7 44.8-51.6 42.2-22.3-2.2-40-19.9-42.2-42.2-.6-6.2-5.7-10.9-11.9-11h-24c3.6-46 43.9-80.3 89.8-76.7 6.6.5 13.1 1.8 19.4 3.9l-26.6 46c-18.2.1-32.9 15-32.8 33.3.1 18.2 15 32.9 33.3 32.8 11.2-.1 21.5-5.7 27.7-15 2-2.9 1.3-6.8-1.6-8.8-2.9-2-6.8-1.3-8.8 1.6-.1.1-.1.2-.2.3-6.2 9.5-18.9 12.2-28.4 6-9.5-6.2-12.2-18.9-6-28.4s18.9-12.2 28.4-6c2.4 1.6 4.5 3.6 6 6 1.9 2.9 5.8 3.7 8.8 1.8 2.2-1.4 3.2-4 2.7-6.5l26.8-46.3c16.3 14.3 26.3 34.4 27.8 56h-24.5c-6.4 0-11.6 4.8-12.1 11zm6.8-106.9c1.1-2 3.6-2.7 5.6-1.7 2 1 2.9 3.5 1.8 5.6 0 .1-.1.2-.1.2l-13.3 22.9c-2.9 5-24.9 43.3-28.1 48.6-2.3-1.7-4.7-3.1-7.3-4.3l41.4-71.3zm172.3 213c0 2.9-2.4 5.3-5.3 5.3H29c-2.9 0-5.3-2.4-5.3-5.3v-99.2c0-2.9 2.4-5.3 5.3-5.3h58.9l-.1-.1h102.9c.2 1.8.5 3.7.8 5.4 6.4 32.4 37.8 53.4 70.2 47 25.7-5.1 45.1-26.3 47.8-52.4h102.7l-.1.1h59c2.9 0 5.3 2.4 5.3 5.3v99.2z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-67.5 371.132 274.442)",
    className: "st0",
    cx: 371.1,
    cy: 274.4,
    r: 14.7
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 424.7,
    cy: 274.5,
    r: 14.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315 259.8c-1.9.4-3.9.8-5.8 1.1-7.5 3.1-11.2 11.7-8.1 19.2 3.1 7.5 11.7 11.2 19.2 8.1 7.5-3.1 11.2-11.7 8.1-19.2-2.2-5.5-7.5-9.1-13.4-9.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDadicateWebHosting);
export default __webpack_public_path__ + "static/media/dadicate-web-hosting.e11d8a42c15da27292d44e0a6568e93a.svg";
export { ForwardRef as ReactComponent };